import { useDynamicWidth } from "./useDynamicWidth";

export function useSiteMargin() {
  return useDynamicWidth(30, 61);
}
